import { forwardRef } from "react";
import { SheetFrame, F } from "@/components/sheets/SheetFrame";
import { hasPlan } from "@/lib/corners";

export const ThreeSheet = forwardRef(({ item, tb, sheetNo, total, snap }, ref) => (
  <SheetFrame svgRef={ref} item={item} tb={tb} sheetNo={sheetNo} total={total} suffix="V" kind="3D VIEW"
    title="3D VIEW" subtitle={`ILLUSTRATIVE 3D VIEW${hasPlan(item) ? " · FOLDED AT THE CORNER ANGLES" : ""} · VIEWED FROM OUTSIDE · NOT TO SCALE`} scaleText="NTS">
    {snap
      ? <image href={snap} x={12} y={30} width={286} height={250} preserveAspectRatio="xMidYMid meet" data-testid="three-sheet-image" />
      : <text x={155} y={150} fontSize={4} fill="#999" fontFamily={F} textAnchor="middle">Preparing 3D view…</text>}
    <text x={16} y={284.5} fontSize={2} fontFamily={F} fill="#555">Rendered from the elevation geometry (frames, mullions, corner posts, sashes, glass). Colours indicative of the specified finish and glass.</text>
  </SheetFrame>
));
ThreeSheet.displayName = "ThreeSheet";
